var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Webcam"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.6626 11.8813L15.8065 13.216C16.926 14.5222 17.4858 15.1753 17.4995 15.7282C17.5114 16.2087 17.3003 16.6678 16.9277 16.9714C16.4989 17.3209 15.6388 17.3209 13.9185 17.3209H6.08166C4.36125 17.3209 3.50104 17.3209 3.07229 16.9714C2.69967 16.6677 2.48855 16.2087 2.50048 15.7282C2.5142 15.1752 3.07404 14.5221 4.1937 13.2159L5.33766 11.8813M15.4394 8.77303C15.4394 11.7772 13.0041 14.2126 9.99989 14.2126C6.99572 14.2126 4.56036 11.7772 4.56036 8.77303C4.56036 5.76886 6.99572 3.3335 9.99989 3.3335C13.0041 3.3335 15.4394 5.76886 15.4394 8.77303ZM12.3311 8.77303C12.3311 10.0605 11.2874 11.1043 9.99989 11.1043C8.71239 11.1043 7.66867 10.0605 7.66867 8.77303C7.66867 7.48553 8.71239 6.4418 9.99989 6.4418C11.2874 6.4418 12.3311 7.48553 12.3311 8.77303Z",
    stroke: "#f37321",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCount);
export default __webpack_public_path__ + "static/media/camera-count.80050f70727b1cdcf94b0ed9672b9fa2.svg";
export { ForwardRef as ReactComponent };